<template>
  <div class="viewer-wrapper">
    <DocumentPreviewTopbar />
    <div class="viewer-container">
      <BbLoadingIndicator v-if="canvasLoading" class="viewer-container__loader" />
      <EditorCanvas
        iframe-name="preview"
        :content="editorContent"
        @loading="onCanvasLoading(true)"
        @load="onCanvasLoading(false)"
      />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { EditorCanvas, useWesley } from '@anthill-modules/wesley-components';

import DocumentPreviewTopbar from '~/components/conversation/authoring/documentPreview/DocumentPreviewTopbar.vue';

export default {
  components: {
    DocumentPreviewTopbar,
    EditorCanvas,
  },
  props: {
    editorContent: {
      type: String,
      required: true,
    },
  },
  setup() {
    const { iframeWindow } = useWesley('preview');
    const canvasLoading = ref(true);

    const applyScrollbarHiddenStyle = () => {
      const iframeDoc = iframeWindow.value?.document;
      if (iframeDoc) {
        const style = iframeDoc.createElement('style');
        style.textContent = `
          ::-webkit-scrollbar {
            display: none;
          }
        `;
        iframeDoc.head.appendChild(style);
      }
    };

    const onCanvasLoading = (isLoading) => {
      canvasLoading.value = isLoading;

      if (!isLoading) {
        applyScrollbarHiddenStyle();
      }
    };

    return {
      canvasLoading,
      onCanvasLoading,
    };
  },
};
</script>

<style scoped lang="scss">
.viewer-wrapper {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;

  .viewer-container {
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: auto;
    background-color: $bb-neutral-6;
    padding-top: $bb-spacing-2;
    position: relative;

    &__loader {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: $bb-neutral-0;
      z-index: 1000;

      :deep(.bounce) {
        background-color: $bb-primary-1 !important;
      }
    }
  }

  :deep(.editor-canvas) {
    overflow: visible;
    padding: 0;
  }
}
</style>
